import { CapoPlugin } from "/opt/buildhome/repo/node_modules/nuxt/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];